<template>
    <div class="home">
        <Header />
        <div class="content">
            <div class="payment">
                <i class="iconfont icongouxuanxuanzhong"></i>
                <p class="success">支付成功</p>
                <p>感谢您对我们的支持，我们会尽快安排发货。</p>
                <p>商品收到后若有问题请及时联系我们处理哟！</p>
                <div class="tips" v-if="tipsVisible">
                    <img src="../../assets/images/gift.png" alt="">
                    {{ tipsText }}
                </div>
                <span class="order-details"
                    @click="checkOrder">查看订单</span>
                <span class="go-home"
                    @click="$router.push('/')">返回首页</span>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import { exist_pay } from '@/services/http'
import Header from '@/common/header.vue'
import Footer from '@/common/footer.vue'

export default {
    components: { Header, Footer },
    data() {
        return {
            tipsVisible: false, // 是否展示虚拟赠品提示行
            tipsText: '' // 赠品提示文案
        }
    },
    created() {
        this.getexchangeRecord()
    },
    methods: {
        // 根据接口返回数据组装赠品提示文案
        // exchangePayShow: 有无白拿（有则带「软件VIP day天」）；day: VIP 天数
        // giftCouponNum: 0 无券句；1 单张满减；>=2 仅张数；receiveStatus: 0 未领取 1 已手动领取
        // fullReduce / reduceMoney: 仅 1 张券时拼入满减文案
        buildTipsInfo(s) {
            const hasBailan = !!s.exchangePayShow
            const n = Number(s.giftCouponNum) || 0
            const claimed = Number(s.receiveStatus) === 1

            if (!hasBailan && n === 0) return

            this.tipsVisible = true
            const vip = `「软件VIP ${s.day}天」`
            const couponOne = `「满${s.fullReduce}减${s.reduceMoney}的优惠券」`

            // 顶层先按「有无白拿」分支
            if (hasBailan) {
                if (n === 0) {
                    this.tipsText = `恭喜你，获得${vip}`
                } else if (n === 1) {
                    this.tipsText = claimed
                        ? `恭喜你，获得${vip}；你领取${couponOne}，本次不再赠送`
                        : `恭喜你，获得${vip}和一张${couponOne}`
                } else if (claimed) {
                    this.tipsText = `恭喜你，获得${vip}和${n}张优惠券（已领取优惠券不再重复赠送）`
                } else {
                    this.tipsText = `恭喜你，获得${vip}和${n}张优惠券`
                }
                return
            } else {
                if (n === 1) {
                    this.tipsText = claimed
                        ? `你已领取${couponOne}，本次不再赠送`
                        : `恭喜你，获得一张${couponOne}`
                } else if (claimed) {
                    this.tipsText = `恭喜你，获得${n}张优惠券（已领取优惠券不再重复赠送）`
                } else {
                    this.tipsText = `恭喜你，获得${n}张优惠券`
                }
            }
        },
        // 查询支付成功后的虚拟赠品信息
        async getexchangeRecord() {
            const res = await exist_pay({ orderNo: this.$route.query.id })
            this.buildTipsInfo(res.data.data)
        },
        checkOrder() {
            if (!this.$route.query.id) {
                this.$router.push('/order-list')
                this.$message.error('数据有误')
            } else {
                this.$router.push(`/order-details?id=${this.$route.query.id}`)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.tips {
    display: flex;
    align-items: center;
    color: #FF8200;
    font-size: 14px;
    margin-top: 20px;

    img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
    }
}

.home {
    height: 100%;
}

.content {
    height: calc(100% - 212px);
}

.payment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    padding-top: 100px;

    i {
        font-size: 40px;
        color: #0043ff;
        margin-bottom: 26px;
    }

    .order-details {
        display: inline-block;
        width: 240px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background: #0043ff;
        box-shadow: 4px 10px 20px 0px rgba(36, 90, 228, 0.2);
        border-radius: 24px;
        cursor: pointer;
        margin: 32px 0 16px;

        &:hover {
            background: rgba(34, 116, 229, 0.8);
        }
    }

    .go-home {
        display: inline-block;
        width: 235px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        cursor: pointer;
        border: 1px solid rgba(102, 102, 102, 1);

        &:hover {
            color: #fff;
            background: #0043ff;
            border: 1px solid #0043ff;
        }
    }

    p {
        margin-bottom: 5px;
    }

    .success {
        margin-bottom: 10px;
        color: #0043ff;
        font-size: 20px;
    }
}

.takefree {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #ff8200;
    margin-top: 10px;

    img {
        width: 20px;
        margin-right: 8px;
    }
}
</style>